var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useAuth } from "./use-auth";
import { gql } from '@apollo/client';
import { useAppState } from "./use-app-state";
import React from "react";
import { useAccessToken } from "./use-access-token";
import { useReady } from "./use-ready";
import { useSafeApolloClient } from "./use-safe-apollo-client";
export function useActivePerson(options) {
  var _this = this;
  var _a, _b;
  var queryExtraFields = (options || {}).queryExtraFields;
  var isReady = useReady().isReady;
  var _c = __read(useAppState(), 3),
    appState = _c[0],
    setAppState = _c[1],
    patchAppState = _c[2];
  var client = useSafeApolloClient();
  var _d = useAuth(),
    user = _d.user,
    isAuthenticated = _d.isAuthenticated;
  var accessToken = useAccessToken();
  // Added followingPages and followingSpaces to the person query as there were caching issues
  // with the "queryExtraFields" when querying for these fields in the EntityFollowControls
  var ACTIVE_PERSON_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ActivePersonQuery($id: ID!) {\n      person(id: $id) {\n        id\n        uid\n        name\n        path\n        slug\n        agreesToTerms\n        canAdmin\n        mustChangePassword\n        followingPages { id name title slug path sitePath }\n        followingSpaces { id name slug path sitePath }\n        photo { url thumbnails { small { url }} }\n        bio { text }\n        ", "\n      }\n    }\n  "], ["\n    query ActivePersonQuery($id: ID!) {\n      person(id: $id) {\n        id\n        uid\n        name\n        path\n        slug\n        agreesToTerms\n        canAdmin\n        mustChangePassword\n        followingPages { id name title slug path sitePath }\n        followingSpaces { id name slug path sitePath }\n        photo { url thumbnails { small { url }} }\n        bio { text }\n        ", "\n      }\n    }\n  "])), queryExtraFields ? queryExtraFields : '');
  React.useEffect(function () {
    if (isReady && (user === null || user === void 0 ? void 0 : user.id) && !(appState === null || appState === void 0 ? void 0 : appState.activePerson) && accessToken) {
      var fetchPerson = function () {
        return __awaiter(_this, void 0, void 0, function () {
          var response;
          var _a;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                setAppState(__assign(__assign({}, appState), {
                  activePerson: {
                    isLoading: true
                  }
                }));
                return [4 /*yield*/, client.query({
                  query: ACTIVE_PERSON_QUERY,
                  variables: {
                    id: user.id
                  },
                  context: {
                    headers: {
                      Authorization: "Bearer ".concat(accessToken)
                    }
                  },
                  fetchPolicy: 'network-only'
                })];
              case 1:
                response = _b.sent();
                setAppState(__assign(__assign({}, appState), {
                  activePerson: {
                    isLoading: false,
                    isAvailable: true,
                    person: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.person
                  }
                }));
                return [2 /*return*/];
            }
          });
        });
      };
      fetchPerson();
    }
  }, [isReady, user, isAuthenticated, accessToken]); // added isReady to deps
  return {
    isLoading: !isReady || !appState.activePerson || appState.activePerson.isLoading,
    isAvailable: isReady && !!((_a = appState.activePerson) === null || _a === void 0 ? void 0 : _a.isAvailable),
    person: isReady ? (_b = appState.activePerson) === null || _b === void 0 ? void 0 : _b.person : null
  };
}
var templateObject_1;